export const MIN_SINGLE_CARDS = 5;
export const MIN_PAIRS = 3;
export const MIN_TRIPLES = 2;

export const TYPE_0_PASS = 0;
export const TYPE_1_SINGLE = 1;
export const TYPE_2_PAIR = 2;
export const TYPE_3_TRIPLE = 3;
export const TYPE_4_BOMB = 4;
export const TYPE_5_KING_BOMB = 5;
export const TYPE_6_3_1 = 6;
export const TYPE_7_3_2 = 7;
export const TYPE_8_SERIAL_SINGLE = 8;
export const TYPE_9_SERIAL_PAIR = 9;
export const TYPE_10_SERIAL_TRIPLE = 10;
export const TYPE_11_SERIAL_3_1 = 11;
export const TYPE_12_SERIAL_3_2 = 12;
export const TYPE_13_4_2 = 13;
export const TYPE_14_4_22 = 14;
export const TYPE_15_WRONG = 15;

export function select(cards, num) {
    const result = [];
    const combo = [];
    function comb(start) {
        if (combo.length === num) {
            result.push(combo.slice());
            return;
        }
        for (let i = start; i < cards.length; i++) {
            combo.push(cards[i]);
            comb(i + 1);
            combo.pop();
        }
    }
    comb(0);
    return result;
}

export function countCards(move) {
    const dict = {};
    move.forEach((c) => {
        dict[c] = (dict[c] || 0) + 1;
    });
    return dict;
}

export function uniqueMoves(moves) {
    const seen = new Set();
    const out = [];
    moves.forEach((m) => {
        const key = JSON.stringify([...m].sort((a, b) => a - b));
        if (!seen.has(key)) {
            seen.add(key);
            out.push([...m].sort((a, b) => a - b));
        }
    });
    return out;
}
